import axios from "axios"
import baseURL from "../config/api"

export const post_LeadershipGroup = (data: any, userId: number, token: string) => {
    return axios({
        url: `${baseURL}leadershipGroups`,
        method: "POST",
        params: { userId },
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_LeadershipGroup = (data: any, userId: number, token: string) => {
    return axios({
        url: `${baseURL}leadershipGroups?${userId}`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_LeadershipGroup = (primaryKey: string, userId: number, token: string) => {
    return axios({
        url: `${baseURL}leadershipGroups`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: { id: primaryKey, userId }
    }).then(response => response.data);
}

export const getleadershipGroupsByGroupId = (groupId: number, token: string) => {
    return getFetch("leadershipGroups", token, { groupId })
}

export const getLeadershipGroup = (primaryKey: string, token: string) => {
    return getFetch(`leadershipGroups/${primaryKey}`, token)
}

const getFetch = (url: string, token: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}